import React from "react";

export default function SectionHeading({ eyebrow, title, subtitle, align = "left", testId }) {
  return (
    <div data-testid={testId} className={`${align === "center" ? "text-center mx-auto" : ""} max-w-3xl`}>
      {eyebrow && <div className={`caption text-[#B5896E] mb-5 flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`}>
        <span className="inline-block w-8 h-[1px] bg-[#B5896E]" />
        {eyebrow}
      </div>}
      <h2 className="font-display text-4xl lg:text-5xl leading-[1.05] text-[#4A3F35]">{title}</h2>
      {subtitle && <p className="mt-6 text-base lg:text-lg text-[#4A3F35]/70 leading-relaxed">{subtitle}</p>}
    </div>
  );
}
